module.exports = __webpack_public_path__ + "static/img/bg_login.26e3d631.png";